import { HateoasClient } from '@/plugins/hateoas-client'

import { Activity, ActivityInput } from './interfaces'

class ActivityApi extends HateoasClient<Activity, ActivityInput> {}

export const activityApi = new ActivityApi('v1', 'activities')
